import { IMeasureVM, MeasuresAdminService, MeasureVM } from "../measures-admin-service";
import { IValidationErrorsAM } from "../../../../utils/validation";
import { ResourcedNotificationService, NotificationType } from "../../../../components/notifications/notification-service";
import { Router } from "aurelia-router";
import { autoinject } from "aurelia-framework";
import { AppSettings } from "../../../../utils/appsettings";

@autoinject
export class MeasureCreate {
	measure: MeasureVM;
	languages: string[] = [AppSettings.lang];
	validationErrors: IValidationErrorsAM = null;

	constructor(private service: MeasuresAdminService, private notificationService: ResourcedNotificationService, private router: Router) {}

	bind() {
		this.measure = new MeasureVM();
		this.measure.aggregationRuleName = 'SumOnlyFromMunicipalities';
	}

	async createMeasure(measure: MeasureVM) {
		this.validationErrors = null;
		
		const response = await this.service.createMeasure(measure);

		if(response.ok) {
			this.notificationService.push('ViewMessage_SaveSucceeded', NotificationType.Success);
			this.router.navigateToRoute('measure-edit', { measureId: (await response.json()).id });
		} else {
			this.validationErrors = await response.json();
		}
	}
}
